export { carouselExtensionType, carouselExtensionKey, FRAMES_LIMIT_V2 } from './constants';

export {
	getExtensionNodeFromParams,
	mockInitialCarouselParameters,
	mockV2Carousel10FramesParameters,
} from './mocks';

export { type Frame, type CarouselParameters, CornerStyle, NavigationStyle } from './types';

export { carouselExtensionProvider } from './ui/carousel-manifest';
export { Carousel } from './ui/carousel-extension/renderer';

export { CarouselConfigPanelContent } from './ui/carousel-config-panel';
export { carouselHubElement } from './ui/carousel-hub-element';
